import { Typography, useTheme, Grid, Stack } from '@mui/material';
import { FixtureComparisonRating } from '@/service/types';
import { ComparisonGrid } from '@/components/ComparisonRating/common';

interface ComparisonRatingInfoProps {
  comparisonRating: FixtureComparisonRating;
}

export const ComparisonRatingInfo = ({
  comparisonRating,
}: ComparisonRatingInfoProps) => {
  const theme = useTheme();

  return (
    <ComparisonGrid container flex={1}>
      <Grid item xs={6} md={3} padding={0}>
        <Typography whiteSpace='nowrap'>Data Collector:</Typography>
      </Grid>
      <Grid item xs={6} md={9} padding={0}>
        <Stack flexDirection='row' gap={theme.spacing(0.5)}>
          <Typography fontWeight='bold'>
            {comparisonRating?.user.firstname} {comparisonRating?.user.lastname}
          </Typography>
          <Typography>{comparisonRating?.role.name}</Typography>
        </Stack>
      </Grid>
    </ComparisonGrid>
  );
};
